mutation AddPdlContactsToAccount($input: AccountPdlContactsAddInput!) {
    accountPdlContactsAdd(input: $input) {
        account {
            id
            name
            contacts {
                totalCount
            }
        }
        contacts {
            id
            name
        }
    }
}
